import classNames from 'classnames';

import { IcMicOff16Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import styles from './styles.m.css';

const MutedBadge = ({ className }) => {
  return (
    <div className={classNames(styles.iconContainer, className)}>
      <IconView
        Icon={IcMicOff16Icon}
        size="small"
        className={styles.icon}
      />
    </div>
  );
};

export default MutedBadge;
